module.exports = __webpack_public_path__ + "static/media/endo.4b330781.jpg";